export default function Contact() {
    return (
      <div id="location" className="bg-white py-16 px-6 sm:py-24 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-base font-semibold text-indigo-600">Location & Contact</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Visit Us & Get in Touch
          </p>
        </div>
  
        {/* Google Map */}
        <div className="mt-10 mx-auto w-full max-w-4xl rounded-lg overflow-hidden shadow-lg">
          <iframe
            title="Location"
            className="w-full h-80 sm:h-96"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15561.738599896004!2d80.21960330898438!3d12.81516581408103!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525bedc2119e2b%3A0x5b5e0b0fd090fc8c!2sPAVANS%20BADMINTON%20ACADEMY!5e0!3m2!1sen!2sin!4v1740382665822!5m2!1sen!2sin"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
  
        {/* Contact Details */}
        <div className="mt-10 text-center">
          <p className="text-lg font-medium text-gray-900">
            📍 <strong>1/56, Near Supreme Hospital, Padur, OMR</strong><br />
            <span className="text-gray-600">Next to MKT Tower Ladies Hostel</span>
          </p>
          <p className="mt-4 text-lg font-medium text-gray-900">
            🕒 <strong>Working Hours:</strong> 24 / 7
          </p>
          <p className="mt-4 text-lg font-medium text-gray-900">
            📞 <a href="tel:+918100376761" className="text-indigo-600 hover:underline">+91 918100376761</a>
          </p>
          <p className="mt-2 text-lg font-medium text-gray-900">
            💬 <a href="https://wa.me/+918100376761" className="text-green-600 hover:underline">WhatsApp Us</a>
          </p>
        </div>
      </div>
    )
  }
  